import { render } from "./MetadataVariableQuestionnaireText.vue?vue&type=template&id=719babb3&scoped=true"
import script from "./MetadataVariableQuestionnaireText.vue?vue&type=script&lang=js"
export * from "./MetadataVariableQuestionnaireText.vue?vue&type=script&lang=js"

import "./MetadataVariableQuestionnaireText.vue?vue&type=style&index=0&id=719babb3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719babb3"]])

export default __exports__